'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNewScores = exports.calculateResetScores = exports.DEFAULT_INCREMENT = undefined;

var _lodash = require('lodash');

// 2^16 (Trello seem to do this...)
var DEFAULT_INCREMENT = exports.DEFAULT_INCREMENT = 65536; // Lib
var calculateResetScores = exports.calculateResetScores = function calculateResetScores(size) {
    var scoresArray = [];
    for (var i = 0; i < size; i++) {
        scoresArray[i] = i * DEFAULT_INCREMENT;
    }
    return scoresArray;
};

/* eslint-disable eqeqeq */
var calculateIncrement = function calculateIncrement(prevScore, nextScore, insertCount) {
    // == checks for undefined & null
    if (nextScore == null) return DEFAULT_INCREMENT;
    if (prevScore == null) return -DEFAULT_INCREMENT;
    return (nextScore - prevScore) / (insertCount + 1);
};

/* eslint-disable eqeqeq */
var calculateStartingScore = function calculateStartingScore(prevScore, nextScore, increment) {
    // == checks for undefined & null
    // If there's nothing in the list we start at 0
    if (prevScore == null && nextScore == null) return 0;
    // If there's nothing before this insert, then start at the nextScore plus the increment (which will be negative)
    if (prevScore == null) return nextScore + increment;
    // Otherwise just add the increment to the previous score
    return prevScore + increment;
};
/* eslint-enable eqeqeq */

/**
 * Returns an array of scores for each inserted element, or null if a score collision occurs.
 *
 * @param scores {[Number]} The array of existing scores to insert new scores into.
 * @param index {Number} The index to insert new scores at.
 * @param insertCount {Number} The number of scores to insert.
 */
var getNewScores = exports.getNewScores = function getNewScores(scores, index, insertCount) {
    var prevScore = scores[index - 1];
    // The old score at this index will become the next score after the insert
    var nextScore = scores[index];

    var increment = calculateIncrement(prevScore, nextScore, insertCount);
    var startScore = calculateStartingScore(prevScore, nextScore, increment);

    // Score collision - the scores must be recalculated as we have hit the limit
    if (startScore === prevScore || startScore === nextScore) return null;

    var endScore = startScore + insertCount * increment;

    return (0, _lodash.range)(startScore, endScore, increment);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/listOrderScores/scoreCalculator.js
// module id = 794
// module chunks = 0